module.exports = __webpack_public_path__ + "html/vehicle-export.component.html";